module.exports = __webpack_public_path__ + "img/alert-triangle.f6247eb7.svg";